import { ApiSetting, Setting } from '../models/setting'

export function parseSettings(settings: ApiSetting[]): Setting {
  if(settings)
    return settings.reduce((prev, cur) => {
      if ((cur && cur.platform === 'all' || cur && cur.platform === 'web') || !(cur && cur.platform)) {
        prev[cur.key] = cur.value
        return prev
      } else {
        return prev
      }
    }, {})
  else
    return {}
}
